import React from 'react';
import { motion } from 'framer-motion';
import { FaGraduationCap, FaCalendarAlt } from 'react-icons/fa';
import './Education.css';

const education = [
  {
    school: 'Sunway College',
    location: 'Maitidevi, Nepal',
    degree: 'BSc (Hons) Computer and Data Science',
    period: '2023 – 2026',
    coursework: ['Machine Learning', 'Deep Learning', 'NLP', 'Data Analysis', 'REST API Development', 'AWS'],
  },
  {
    school: 'Khwopa Secondary School',
    location: 'Bhaktapur, Nepal',
    degree: 'Grade 12, Computer Science – 3.2 GPA',
    period: '2020 – 2022',
    coursework: ['Calculus', 'Programming'],
  },
];

const Education = () => {
  return (
    <section id="education" className="education">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Education'}</span>
          <h2 className="section-title">Academic Background</h2>
        </div>

        <div className="education__grid">
          {education.map((edu, idx) => (
            <motion.div
              className="education__card"
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.15 }}
            >
              <div className="education__icon-wrap">
                <FaGraduationCap />
              </div>
              <div className="education__info">
                <h3 className="education__school">{edu.school}</h3>
                <p className="education__location">{edu.location}</p>
                <h4 className="education__degree">{edu.degree}</h4>
                <span className="education__period">
                  <FaCalendarAlt /> {edu.period}
                </span>
                <div className="education__coursework">
                  <span className="education__coursework-label">Relevant Coursework:</span>
                  <div className="education__tags">
                    {edu.coursework.map((c) => (
                      <span className="tag" key={c}>{c}</span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
